import type { Endpoint, Route, Request, RequestArgs, AbortableRequest } from '../types.no-deps'
import type { Step } from '../../../shared/domain/flows/types.no-deps'

export const maxPromptLength = 20000

export const route: Route = { method: 'POST', pattern: '/api/workflows/:id/steps/generated' }

type Params = { id: number }
type Body = {
    prompt: string
    limitToGuide?: boolean
}
type Query = never
type Output = Step[]

export type GetGeneratedStepsEndpoint = Endpoint<Params, Body, Query, Output>

export const getGeneratedStepsRequest = (request: Request, args: RequestArgs<GetGeneratedStepsEndpoint>) =>
    request<GetGeneratedStepsEndpoint>(route, args)

export const getGeneratedStepsAbortable = (request: AbortableRequest, args: RequestArgs<GetGeneratedStepsEndpoint>) =>
    request<GetGeneratedStepsEndpoint>(route, args)
